import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {
  private base_url = `${environment.API_URL}/config`;

  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient) {}

  getConfigs(): Observable<any> {
    return this.http.get(this.base_url, { headers: this.headers });
  }

  createConfig(config: { key: string, value: string }): Observable<any> {
    return this.http.post(this.base_url, config, { headers: this.headers });
  }

  updateConfig(id: number, config: { key: string, value: string }): Observable<any> {
    return this.http.put(`${this.base_url}/${id}`, config, { headers: this.headers });
  }

  deleteConfig(id: number): Observable<any> {
    return this.http.delete(`${this.base_url}/${id}`, { headers: this.headers });
  }

  getConfigByKey(key: string): Observable<any> {
    const url = `${this.base_url}/key/${key}`; // Assuming your API supports this endpoint
    return this.http.get(url, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/config.service.ts